import { Component, OnInit } from "@angular/core";
import { ActionsService } from "src/app/services/routing/actions.service";
import { ConfigService } from "src/app/services/config/config.service";
import { ControlService } from "src/app/services/control/control.service";

interface CobrandConfig {
  enabled: boolean;
  image?: string;
  actionType?: string;
  url?: string;
}

@Component({
  selector: "app-site-logo",
  templateUrl: "./site-logo.component.html",
  styleUrls: ["./site-logo.component.scss"],
  standalone: true
})
export class SiteLogoComponent implements OnInit {

  public cobrandLogoUrl: string;
  public cobrandAvailable = false;
  public cobrandActionType = "default";
  public cobrandImageName = "logo_cobrand.svg";
  public cobrandUrl?: string;

  constructor(
    private actions: ActionsService,
    private config: ConfigService,
    private control: ControlService,
  ) { }

  ngOnInit(): void {
    const config = this.config.getConfig() ?? {};
    const rawCobrand = config.CDN_IMAGE_COBRAND;

    if (rawCobrand && rawCobrand !== "undefined") {
      try {
        const parsed: CobrandConfig = JSON.parse(rawCobrand);

        if (parsed.enabled) {
          this.cobrandAvailable = true;

          if (parsed.image) {
            this.cobrandImageName = parsed.image;
          }

          if (parsed.actionType) {
            this.cobrandActionType = parsed.actionType;
          }

          if (parsed.url) {
            this.cobrandUrl = parsed.url;
          }
        }
      } catch {
        console.warn("Invalid cobrand config JSON");
      }
    }
    
    if (this.cobrandAvailable) {
      this.cobrandLogoUrl = `${config?.CDN_BASEURL}/assets/imgs/${this.cobrandImageName}`;
    }
  }

  public onLogoClick(): void {
    this.control.goToDefaultCategory();
  }

  public onCobrandAction(): void {
    this.actions.action(this.cobrandActionType);
  }

}